<template>
    <div>
        <h1 class="text-gray-900 text-3xl font-semibold">{{ $tc('oops', 1) }}</h1>
        <h3 class="mt-2 text-gray-700 text-xl">{{ $tc('page_not_there', 1) }}</h3>
        <router-link :to="{ name: 'dashboard' }" class="block mt-6 text-blue-600">{{ $tc('back_to_dashboard', 1) }}</router-link>
    </div>
</template>
